import type { ReactNode } from 'react';
import { lazy } from 'react';
const TrophyIcon = lazy(() => import('../../../../../components/SVGIcons/TrophyIcon'));

import classNames from 'classnames';

import styles from './TournamentSmallWidget.module.scss';

interface TournamentSmallWidgetProps {
  positionValue: string | null;
  widgetImageUrl?: string;
  timer?: ReactNode;
}

export function TournamentSmallWidget(props: TournamentSmallWidgetProps) {
  const { widgetImageUrl, positionValue, timer } = props;
  const noPosition = !positionValue;

  return (
    <div className={styles.container}>
      {widgetImageUrl ? (
        <img alt="" className={styles.imgGeneral} src={widgetImageUrl} />
      ) : (
        <TrophyIcon className={styles.imgGeneral} />
      )}
      <div className={classNames(styles.content, noPosition && styles.noPositionContent)}>
        <div className={classNames(styles.counterContainer, noPosition && styles.noPositionCounterContainer)}>
          <span className={styles.counterText}>{positionValue}</span>
        </div>
        <div className={classNames(styles.timerContainer, noPosition && styles.noPositionTimerContainer)}>{timer}</div>
      </div>
    </div>
  );
}
